import React, { Component } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import PhonelinkLockIcon from "@mui/icons-material/PhonelinkLock";
import { Button, Col, Input, Row} from "antd";
import { connect } from "react-redux";
import { login } from "../redux_actions/login.action";
import { Link } from "react-router-dom";
import { checkIfMobile } from "../utils/utils";
import { MorphleLogo } from "../utils/const";
import { clearLoginFailureMessage, storeUserCredentials, setIsTotpEnabled } from "../redux_actions/login.action";
import "../asset/style/login.css";

class TotpLoginForm extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.totpCodeInputRef = React.createRef();
        this.state = {
            isFetching: false,
            capsLockOn: false,
        };
    }

    componentDidMount = () => {
        let isMobile = checkIfMobile();
        document.documentElement.style.setProperty("--login-div-size", isMobile ? "20em" : "40em");
        this.props.dispatch(clearLoginFailureMessage());
        this.totpCodeInputRef.current.focus();
    };

    handleSubmit = (e) => {
        e?.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.dispatch(login(values));
            }
        });
    };

    getTotpPrefix = () => {
        return <PhonelinkLockIcon style={{ color: "rgba(0,0,0,.25)", fontSize: 15 }} />;
    };

    handleClick = () => {
        this.props.dispatch(storeUserCredentials({ username: null, password: null }));
        this.props.dispatch(clearLoginFailureMessage());
        this.props.dispatch(setIsTotpEnabled(false));
    };

    renderForm() {
        const { getFieldDecorator } = this.props.form;
        let content = [];
        content = content.concat([
            <Form.Item style={{ display: "none" }}>
                {getFieldDecorator("username", {
                    initialValue: this.props.usernameTotp,
                })}
            </Form.Item>,
            <Form.Item style={{ display: "none" }}>
                {getFieldDecorator("password", {
                    initialValue: this.props.passwordTotp,
                })}
            </Form.Item>,
            <Form.Item
                extra={
                    this.state.capsLockOn ? (
                        <label style={{ color: "rgba(255, 191, 0, 1)" }}>CapsLock is On</label>
                    ) : (
                        <label style={{ color: "rgba(0, 0, 0, 0)" }}>CapsLock is Off</label>
                    )
                }
            >
                {getFieldDecorator("totp_code", {
                    rules: [{ required: true, message: "Please input your totp!" }],
                })(<Input prefix={this.getTotpPrefix()}  
                    ref={this.totpCodeInputRef} 
                    placeholder="XXXXXX" />)}
            </Form.Item>,
            <Form.Item style={{ display: "none" }}>
                {getFieldDecorator("csrfmiddlewaretoken", {
                    valuePropName: "Checked",
                    initialValue: this.props.csrfToken,
                })}
            </Form.Item>,
        ]);
        if (this.props.isWrongCredential) {
            content.push(<div style={{ color: "red" }}>{this.props.loginFailureMessage}</div>);
        }
        content.push(
            <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button" loading={this.props.isFetching}>
                    Verify
                </Button>
            </Form.Item>
        );

        return content;
    }

    renderContent() {
        let content = [];
        content.push(
            <div className="totp-container">
                <PhonelinkLockIcon style={{ fontSize: "40px" }} />
                <p className="totp-info unselectable">Authentication code</p>
            </div>
        );

        if (this.props.demoLogin) {
            let elems = [
                <p key={0} className="demo-login">
                    For Accessing Demo Scans
                </p>,
                <p key={1} className="demo-login">
                    <b>username</b> : morphledemo
                </p>,
                <p key={2} className="demo-login">
                    <b>password</b> : demouser1234
                </p>,
            ];
            content = content.concat(elems);
        }

        content.push(
            <Form ref={this.formRef} onSubmit={this.handleSubmit} ST>
                {this.renderForm()}
            </Form>
        );

        content.push(
            <p className="totp-info-bottom unselectable">
                Open your two-factor authenticator (TOTP) app or browser extension to view your authentication code.
            </p>
        );
        content.push(
            <p className="totp-info-bottom unselectable">
                <p>
                    Having problems? <Link to="/recovery_totp">Use a recovery code.</Link>
                </p>
            </p>
        );

        return content;
    }

    render() {
        return (
            <Row>
                <Col className="login-form overlayed-component">
                    <div className="totp-header">
                        <Link to="/login" className="totp-back-button" onClick={this.handleClick}>
                            <ArrowLeftOutlined />
                        </Link>
                        <img className="login-logo-totp " src={MorphleLogo} alt={"Morphle Logo"} />
                    </div>
                    {this.renderContent()}
                </Col>
            </Row>
        );
    }
}

const WrappedNormalTotpLoginForm = Form.create()(TotpLoginForm);

const mapStateToProps = (state) => {
    return state.loginAlerts;
};

export default connect(mapStateToProps)(WrappedNormalTotpLoginForm);
